"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _ShapeCreativeLayer = _interopRequireDefault(require("../../models/creative/ShapeCreativeLayer"));

var _LayerRenderer2 = _interopRequireDefault(require("./LayerRenderer"));

var _creative = require("../../constants/creative");

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _ShapeFrameData = _interopRequireDefault(require("../store/ShapeFrameData"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ShapeRenderer = /*#__PURE__*/function (_LayerRenderer) {
  (0, _inherits2["default"])(ShapeRenderer, _LayerRenderer);

  var _super = _createSuper(ShapeRenderer);

  function ShapeRenderer(creativeLayer, contentStore, layerTransformer, filterProcessor) {
    var _this;

    (0, _classCallCheck2["default"])(this, ShapeRenderer);
    _this = _super.call(this, creativeLayer, contentStore, layerTransformer, filterProcessor);

    if (!_ShapeCreativeLayer["default"].isShapeCreativeLayer(creativeLayer)) {
      throw new Error('Must be initialized with a creative layer of the content type SHAPE');
    }

    _this._contentWidth = 400;
    _this._contentHeight = 400;
    return _this;
  }
  /**
   * @override
   */


  (0, _createClass2["default"])(ShapeRenderer, [{
    key: "drawLayerAtFrame",
    value: function drawLayerAtFrame(context, currentFrame, contentFrameData, layerTransformData) {
      var fillColor = contentFrameData.fillColor,
          shape = contentFrameData.shape;
      context.translate(-200, -200);
      context.beginPath();
      context.fillStyle = fillColor;

      if (shape === _creative.SHAPE.SQUARE) {
        context.rect(0, 0, 400, 400);
      } else if (shape === _creative.SHAPE.CIRCLE) {
        context.arc(200, 200, 200, 0, 2 * Math.PI);
      } else if (shape === _creative.SHAPE.STAR) {
        context.moveTo(200, 300.1);
        context.lineTo(82.44, 361.9);
        context.lineTo(104.89, 231);
        context.lineTo(9.79, 138.29);
        context.lineTo(141.22, 119.2);
        context.lineTo(200, 0.1);
        context.lineTo(258.78, 119.2);
        context.lineTo(390.21, 138.29);
        context.lineTo(295.11, 231);
        context.lineTo(317.56, 361.9);
        context.lineTo(200, 300.1);
      }

      context.fill();
      context.translate(200, 200);
      this._hasRendered = true;
    }
  }, {
    key: "getContentFrameData",
    value: function getContentFrameData(frameNum) {
      if ((0, _isNil["default"])(this._creativeLayer) || (0, _isNil["default"])(this._creativeLayer.contentId)) return null;
      var content = this.creativeLayer.content; // TODO Optimization Here

      return new _ShapeFrameData["default"](content.shape, content.fillColor);
    }
  }]);
  return ShapeRenderer;
}(_LayerRenderer2["default"]);

exports["default"] = ShapeRenderer;